<template>
    <div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div class="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md">
            <div>
                <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
                    Portal do Cliente
                </h2>
                <p class="mt-2 text-center text-sm text-gray-600">
                    Faça login para acessar suas apólices e histórico
                </p>
            </div>
            <form class="mt-8 space-y-6" @submit.prevent="login">
                <input type="hidden" name="remember" value="true">
                <div class="rounded-md shadow-sm -space-y-px">
                    <div>
                        <label for="email-address" class="sr-only">E-mail</label>
                        <input id="email-address" name="email" type="email" autocomplete="email" required v-model="form.email"
                            class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                            placeholder="Seu E-mail registrado">
                    </div>
                    <div>
                        <label for="password" class="sr-only">Senha</label>
                        <input id="password" name="password" type="password" autocomplete="current-password" required v-model="form.password"
                            class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                            placeholder="Sua senha">
                    </div>
                </div>

                <div>
                    <button type="submit" :disabled="loading"
                        class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-400">
                        {{ loading ? 'Entrando...' : 'Entrar no Portal' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import ClientLoginRepository from '@/services/ClientLoginRepository.vue';
import Swal from 'sweetalert2';

export default {
    name: 'ClienteLoginView',
    data() {
        return {
            form: {
                email: '',
                password: ''
            },
            loading: false,
            service: new ClientLoginRepository()
        };
    },
    methods: {
        async login() {
            this.loading = true;
            try {
                // 1. Tentar logar
                const res = await this.service.doLogin(this.form);
                
                // 2. Se logou, já salva o user pra ter a sessão (com o token)
                const clientUser = res.data;
                window.localStorage.setItem('myClientUser', JSON.stringify(clientUser));

                // 3. Opcional: Buscar dados iniciais do cliente logo em seguida ou deixar para a Dash
                Swal.fire({
                    icon: 'success',
                    title: 'Bem-vindo!',
                    text: 'Login efetuado com sucesso.',
                    timer: 1500,
                    showConfirmButton: false
                });

                // Redireciona para o Portal
                this.$router.push('/portal-cliente/perfil');

            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    title: 'Ops...',
                    text: error.response?.data?.message || 'E-mail ou senha incorretos!',
                });
                window.localStorage.removeItem('myClientUser');
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>
